class Validation {
  static formValidate(value) {
    return value ? '' : '入力してください';
  }
}
export default Validation;
